<template>

    <div class="expert_schedule max-content">
        <top title="专家日程" :color="theme_color"></top>
        <div class="expertInfo">
            <img v-if="expertInfo.photo" :src="expertInfo.photo" alt="" onerror="common.imgError(1,event)">
            <img v-else src="@/assets/images/defaultHead.png" alt="">
            <div class="info_con flex">
                <div class="info">
                    <span>{{ expertInfo.name }}</span>
                    <!-- <p>{{expertInfo.title}}</p> -->
                    <p>{{ expertInfo.company }}</p>
                </div>
                <router-link v-if="meeting_id != 537" class="home_icon flex "
                    :style="{ 'background': schedule_color, 'color': schedule_font_color }"
                    :to="{ path: '/vascularNews/expert/index', query: { writer_id: writer_id, meeting_id: meeting_id } }">
                    <!-- <van-icon name="wap-home-o" /> -->
                    专家主页
                </router-link>
            </div>
        </div>
        <van-tabs v-model="outer_active">
            <van-tab title="专家日程">
                <div class="schedule-block" v-for="(obj, key) in scheduleData" :key="key"
                    @click="changeParentTabs(key)">
                    <h4 class="date" :style="{ background: theme_color ? theme_color : '' }">{{ key }}</h4>
                    <div v-for="(list, key2) in obj" :key="key2">
                        <div class="wrap" v-for="(item, index) in list" :key="index">
                            <div class="schedule-item">
                                <p class="main-hall">{{ item.session_name }}&nbsp;&nbsp;{{ item.hall_name?'('+item.hall_name+')':'' }}</p>
                                <div class="flex" style="justify-content: space-between;">
                                    <p class="time"
                                        :style="{ 'background': schedule_color, 'color': schedule_font_color }">
                                        {{ (item.chapter_start_at.split(' ')[1]).slice(0, 5) }} -
                                        {{ (item.chapter_end_at.split(' ')[1]).slice(0, 5) }}</p>
                                    <p class="expert-title">{{ item.title }}</p>
                                </div>
                                <div class="meeting-name" :style="{ 'color': schedule_font_color }">{{ item.meeting_name
                                    }}</div>
                                <div class="chapter-name">{{ item.chapter_name }}</div>
                                <div class="nav-btn" @click="goLive(item.meeting_id, item.session_id)">
                                    <p>点击按钮，跳转本节详细日程</p> <van-icon name="arrow" />
                                </div>
                            </div>
                            <div class="line"></div>

                        </div>
                    </div>

                </div>

                <!-- 
        <div class="scheduleCon">
            <div class="channellist">
                <div class="channelblock"  v-for="(item,key) in dateTime" :key="key" @click="changeParentTabs(key)" >
                    <span :class="key==active?'active':''" :style="{background:key==active && theme_color?theme_color:''}">{{key}}</span>
                </div>
            </div>
            <table border="1px solid #efefef" >
                <tr class="schedule-head" :style="{'background':schedule_color,'color':schedule_font_color}">
                    <th width="16.67%" v-if="meeting_id==527">专场时间</th>
                    <th width="16.67%" v-if="meeting_id!=527">时间</th>
                    <th width="18.67%">会场</th>
                    <th width="17.67%">{{meeting_id==527?'板块':'会议主题'}}</th>
                    <th width="17.67%" v-if="meeting_id==527">任务时间</th>
                    <th width="16.67%">{{meeting_id==527?'内容':'任务'}}</th>
                    <th width="18.67%" v-if="meeting_id!=527">讲题</th>
                    <th width="11.67%" v-if="meeting_id!=527">直播</th>
                </tr>
                <tbody>
                    <tr v-for="(val) in tableData" :key="val.cdw_id" class="schedule-content">
                        <td v-if="meeting_id==527">{{(val.chapter_start_at.split(' ')[1]).slice(0,5)}}<br/> - <br/>{{(val.chapter_end_at.split(' ')[1]).slice(0,5)}}</td>
                        <td v-if="meeting_id!=527">
                            <p v-if="!val.detail_name"><b>{{(val.chapter_start_at.split(' ')[0]).slice(5)}}</b><br/>{{(val.chapter_start_at.split(' ')[1]).slice(0,5)}}<br/> - <br/>{{(val.chapter_end_at.split(' ')[1]).slice(0,5)}}</p>
                            <p v-if="val.detail_name"><b>{{(val.detail_start_at.split(' ')[0]).slice(5)}}</b><br/>{{(val.detail_start_at.split(' ')[1]).slice(0,5)}}<br/> - <br/>{{(val.detail_end_at.split(' ')[1]).slice(0,5)}}</p>
                        </td>
                        <td v-html="formatSessionName(val.session_name)"></td>
                        <td>{{val.chapter_name}}</td>
                        <td v-if="meeting_id==527">
                            <p v-if="!val.detail_name">{{(val.chapter_start_at.split(' ')[1]).slice(0,5)}}<br/> - <br/>{{(val.chapter_end_at.split(' ')[1]).slice(0,5)}}</p>
                            <p v-if="val.detail_name">{{(val.detail_start_at.split(' ')[1]).slice(0,5)}}<br/> - <br/>{{(val.detail_end_at.split(' ')[1]).slice(0,5)}}</p>
                        </td>
                        <td>{{val.title}}</td>
                        <td v-if="meeting_id!=527">{{val.detail_name}}</td>
                        <td v-if="meeting_id!=527" width="30px">
                            <p v-if="val.live_status!=3 && val.is_show_schedule && val.is_show_live==1 "><img src="../../../assets/images/System/play_icon.png" v-if="meeting_id!=473" @click="goLive(val.meeting_id,val.session_id)"/></p>
                            <p v-if="val.live_status==3 || (val.live_status!=3 && !val.is_show_schedule)">无</p>
                        </td>
                        

                    </tr>
                </tbody>
            </table>
        </div> -->
            </van-tab>
            <!-- <van-tab title="专家简介" v-if="expertInfo.des">
                <p class="description">{{ expertInfo.des }}</p>
            </van-tab> -->
       <!-- <van-tab title="" v-else :disabled="true">

            </van-tab> -->
        </van-tabs>

    </div>
</template>
<script>
import { ExpertInformation, ExpertSchedule, MeetingsDetails } from '../../../config/interface.js'
import Top from '../components/Top'
export default {
    components: {
        Top
    },
    data() {
        return {
            outer_active: 0,
            active: 1,
            writer_id: 0,
            meeting_id: 0,
            dateTime: {},
            parent_id: '',
            scheduleData: {},
            tableData: {},
            expertInfo: {},
            theme_color: '',
            schedule_color: 'rgb(243, 217, 217)',//表头文字底色
            schedule_font_color: 'brown',//表头文字颜色

        }
    },
    mounted() {
        this.meeting_id = this.$route.query.meeting_id ? this.$route.query.meeting_id : this.$route.query.MT_id;
        this.writer_id = this.$route.query.writer_id ? this.$route.query.writer_id : this.$route.query.w_id;
        this.getExpertInfo();
        this.querySchedule();
        if (this.meeting_id == 473) {
            this.theme_color = '#0A318E'
        }
    },
    methods: {
        //专家信息
        getExpertInfo(id) {
            const url = ExpertInformation;
            const method = 'POST';
            let params = {
                writer_id: this.writer_id,
                meeting_id: this.meeting_id
            }
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        let data = res.data;
                        this.expertInfo = {
                            photo: data.photo,
                            name: data.name,
                            company: data.company,
                            title: data.title['name'],
                            positionName: data.title.name,
                            des: data.des
                        }
                        if (data.theme_color) {
                            this.theme_color = data.theme_color;
                        }
                        if (data.schedule_color) {
                            this.schedule_color = data.schedule_color;
                        }
                        if (data.schedule_font_color) {
                            this.schedule_font_color = data.schedule_font_color;
                        }
                        if (common.is_weixin()) {
                            this.setShare(data.name);
                        }
                    }
                })
        },
        setShare(name) {
            const url = MeetingsDetails;
            const method = 'POST';
            let params = {
                meeting_id: this.meeting_id
            }
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        let data = res.data;
                        // this.meeting_dates=data.meeting_dates;
                        //微信浏览器  请求jsdk
                        if (common.is_weixin()) {
                            common.wxShare(name + '的个人主页', '请点击查看', data.shareimg);
                        }
                    }
                })

        },
        //日程
        querySchedule() {
            const url = ExpertSchedule;
            const method = 'POST';
            let params = {
                writer_id: this.writer_id,
                meeting_id: this.meeting_id
            }
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        let data = res.data;
                        this.scheduleData = data;
                        let dateArr = Object.keys(data);
                        if (this.meeting_id == 537) {
                            delete this.scheduleData['全部'];
                            for (let item in this.scheduleData) {
                                if (this.scheduleData[item].hasOwnProperty('全部')) {
                                    delete this.scheduleData[item]['全部'];// 删除key值为‘全部’的键值对 按照时间排序循环数据
                                }
                                console.log(this.scheduleData[item]);
                            }
                            dateArr.shift() // 删除第一个元素
                        }
                        this.tableData = data[dateArr[0]]['全部'];
                        this.parent_id = dateArr[0];
                        this.active = dateArr[0];
                        dateArr.forEach((item, index) => {
                            ;
                            this.$set(this.dateTime, item, Object.keys(data[item])[0]);
                        })
                        // console.log(dateArr,this.dateTime,this.scheduleData,this.tableData);
                    }
                })
        },
        changeParentTabs(val) {
            console.log(val, this.scheduleData)
            this.tableData = this.scheduleData[val]['全部'];
            this.active = val;
        },
        changeChildTabs(value) {
            this.dateTime[this.parent_id] = value;
        },
        goLive(meeting_id, session_id) {
            this.$router.push({
                path: '/vascularNews/meeting/liveDetail',
                query: {
                    'meeting_id': meeting_id,
                    'id': session_id
                }
            })

        },
        formatSessionName(name) {
            let strs = name.split(' ');
            let str = '';
            for (let i = 0; i < strs.length; i++) {
                str = str + strs[i] + "<br/>";
            }
            return str;

        }
    }
}
</script>
<style scoped lang="scss">
.expert_schedule {
    width: 100%;
    height: 100%;
    background: #f4f4f4;

    .expertInfo {
        padding: 10px 20px;
        display: flex;
        background: #fff;

        img {
            width: 100px;
            height: 100%;
        }

        .home_icon {
            align-items: center;
            font-size: 13px;
            color: $color-main;
            height: 25px;
            width: 80px;
            text-align: center;
            line-height: 25px;
            border-radius: 12.5px;
            display: block;

            i {
                font-size: 16px;
                margin-right: 3px;
            }
        }

        .info_con {
            flex: 1;
            padding: 5px 10px;
            flex-direction: column;
            justify-content: space-between;

            .info {
                span {
                    font-size: 14px;
                    font-weight: bold;

                }

                p {
                    color: #666;
                }
            }
        }
    }

    .schedule-block {
        margin: 20px 15px;
        background: #fff;
        border-radius: 10px;
        padding: 20px 15px;

        h4 {
            color: #fff;
            background: #901D22;
            line-height: 30px;
            border-radius: 5px;
            padding: 0 15px;
            font-size: 14px;
            margin-bottom: 10px;

        }

        .line {
            width: 100%;
            height: 1px;
            background: #DFDFDF;
            margin-bottom: 20px;
        }

        .wrap:last-child {

            .line {
                display: none;
            }

            // .schedule-item {
            //     margin-bottom: 0;
            // }
        }

        .schedule-item {
            width: 100%;
            background: #f7f7f7;
            padding: 15px 10px;
            border-radius: 10px;
            margin-bottom: 20px;
            display: flex;
            flex-direction: column;
            gap: 15px;

            .main-hall {
                font-size: 15px;
                font-weight: bold;
            }

            .time {
                width: 100px;
                height: 22px;
                border-radius: 11px;
                text-align: center;
                line-height: 22px;
            }

            .expert-title {
                font-weight: bold;
                font-size: 13px;
            }

            .meeting-name {
                font-size: 14px;
                font-weight: 500;
            }

            .chapter-name {
                font-size: 13px;
                color: #666;
                font-weight: 500;
            }

            .nav-btn {
                background: #fff;
                border-radius: 5px;
                width: 100%;
                padding: 10px;
                color: #666;
                display: flex;
                align-items: center;
                justify-content: space-between;
            }

        }
    }

    .scheduleCon {
        padding-top: 15px;
        background: #f4f4f4;
        margin-bottom: 20px;
    }

    .channellist {
        margin: 10px;
        display: flex;
        flex-wrap: wrap;

        .channelblock {
            margin-left: 2%;
            margin-bottom: 5px;
            border-radius: 5px;
            width: 23%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            span {
                display: block;
                // width:80px;
                // height: 30px;
                line-height: 30px;
                background: #fff;
                color: $color-gray;
                font-size: 13px;
                text-align: center;
                padding: 0 3px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            span.active {
                color: #fff;
                background: $color-main;
            }
        }
    }

    table {
        text-align: center;
        border: 1px solid rgb(209, 196, 196);
        border-collapse: collapse;
        margin: 0 15px 20px 15px;

        th {
            //    background: rgb(243, 217, 217);
            font-size: 12px;
            // color: brown;
            // width:16.67%;
            height: 30px;
            border: 1px solid rgb(209, 196, 196);
        }

        tr {
            font-size: 12px;
            background: white;
            border: 1px solid rgb(209, 196, 196);

            td {
                // width:16.67%;
                border: 1px solid rgb(209, 196, 196);
                word-break: break-all;

                img {
                    width: 25px;
                    height: 25px;
                }
            }
        }
    }

    .description {
        margin: 20px;
        font-size: 15px;
        line-height: 30px;
        color: $color-gray;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/Expert/Detail537.vue